import { StoreProvider } from 'easy-peasy';
import { createRoot } from 'react-dom/client';

import store from './store';
import App from './ui/App';

// Suppress Sendbird defaultProps warning (it's a library issue, not our code)
// eslint-disable-next-line no-console
const originalWarn = console.warn;
// eslint-disable-next-line no-console
console.warn = (...args) => {
  const message = typeof args[0] === 'string' ? args[0] : '';
  // Filter out defaultProps warnings from Sendbird UIKit
  if (
    message.includes('defaultProps') &&
    (message.includes('Sendbird') ||
      message.includes('Support for defaultProps will be removed from function components'))
  ) {
    return;
  }
  originalWarn.apply(console, args);
};

const root = createRoot(document.getElementById('root'));

root.render(
  <StoreProvider store={store}>
    <App />
  </StoreProvider>,
);
